<template>
  <MatchMedia query="(max-width: 760px)" v-slot="{ matches }">
    <ProfileMobile  v-if="matches" />
    <ProfileDesktop v-else />
  </MatchMedia>
</template>
 
<script>
  import { MatchMedia } from "vue-component-media-queries";
  import ProfileMobile from "./Profile_Mobile.vue";
  import ProfileDesktop from "./Profile_Desktop.vue";
 
  export default {
    name: 'Profile',
    components: {
      MatchMedia,
      ProfileMobile,
      ProfileDesktop,
    },
  }
</script> 